import React, { memo, useState, useCallback, useMemo } from 'react';
import { Icon, Tooltip, Popover, createUseStyles } from 'hoi-poi-ui';
import classnames from 'classnames';
import ActionsMenu from "./ActionsMenu";
import { useWeb5Context } from "../../../lib/Web5Context";
import styles from "../styles/index";
const useStyles = createUseStyles(styles, 'MenuOptions');
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  size: "raw",
  name: "moreHoriz",
  color: "currentColor"
});
const MenuOptions = /*#__PURE__*/memo(_ref => {
  let {
    fieldSelector,
    fieldSelectorProps,
    tooltipMenuContent = 'label_table_options_and_export'
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const [visible, setVisible] = useState(false);
  const fieldSelectorClasses = classnames(classes.fieldSelectorIcon, {
    [classes.fieldSelectorIconActive]: visible
  }, 'fm-grid__field-selector-icon');
  const onToggleMenu = useCallback(() => setVisible(!visible), [visible]);
  const visibleOverride = useMemo(() => ({
    root: {
      visible,
      onVisibleChange: onToggleMenu
    }
  }), [visible, onToggleMenu]);
  if (!fieldSelector) return null;
  const content = /*#__PURE__*/React.createElement("div", {
    className: classes.fieldSelectorPopoverContent
  }, /*#__PURE__*/React.createElement(ActionsMenu, {
    fieldSelectorProps: fieldSelectorProps,
    onToggleMenu: onToggleMenu
  }));
  return /*#__PURE__*/React.createElement(Popover, {
    placement: "bottomLeft",
    className: classes.fieldSelectorPopover,
    content: content,
    overrides: visibleOverride
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.fieldSelector,
    onClick: onToggleMenu
  }, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "right",
    content: t(tooltipMenuContent)
  }, /*#__PURE__*/React.createElement("span", {
    className: fieldSelectorClasses
  }, _ref2))));
});
export default MenuOptions;